import { AxiosResponse } from "axios";
import api from "../api/base-api";

const getAll = (): Promise<AxiosResponse> => {
    return api.get("/countries/all", { params: { limit: 500 } });
};

const getAllOemCountries = (appId: string): Promise<AxiosResponse> => {
    return api.get(`/countries/application/${appId}/oem`, {
        params: { limit: 500, page: 1, searchString: "" },
    });
};

const getActiveOemCountries = (): Promise<AxiosResponse> => {
    return api.get(`applications/oem/countries/active`);
};

export { getAll, getAllOemCountries, getActiveOemCountries };
